import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";

/**
 * 根据关键字生成唯一key值
 * @param {string} key [一个关键词]
 * @return {String} [唯一的值]
 */
var uniqueKeyMap = {};
export function uniqueKey(key) {
  var uuid = uniqueKeyMap[key] ? uniqueKeyMap[key] + 1 : 1000;
  uniqueKeyMap[key] = uuid;
  return key + uuid;
}
export function mergeDefault(source, target) {
  if (source === void 0) {
    source = {};
  }

  if (target === void 0) {
    target = {};
  }

  var obj = _extends({}, source);

  _Object$keys(target).forEach(function (key) {
    if (target[key] != null) {
      obj[key] = target[key];
    }
  });

  return obj;
}